import { useTranslation } from 'react-i18next';
import { ActionIcon, Group, Stack, Text, ThemeIcon, Tooltip } from '@mantine/core';
import { IconDownload, IconFileText } from '@tabler/icons-react';
import { useDownloadDocument } from '@/hooks/useDeals';
import type { BargainDocument } from '@/types/deals';

interface StepDocListProps {
  readonly documents: readonly BargainDocument[];
}

// Список документов шага (только просмотр/скачивание). Используется в read-only сводке прошедшего шага.
export default function StepDocList({ documents }: StepDocListProps) {
  const { t } = useTranslation();
  const download = useDownloadDocument();

  if (documents.length === 0) {
    return null;
  }

  return (
    <Stack gap="xs">
      {documents.map((doc) => (
        <Group key={doc.id ?? doc.name} justify="space-between" wrap="nowrap" gap="sm">
          <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
            <ThemeIcon size={28} radius="md" variant="light" color="gray">
              <IconFileText size={16} />
            </ThemeIcon>
            <Text fz="sm" lineClamp={1}>
              {doc.name ?? t('app.deals.docs.untitled')}
            </Text>
          </Group>
          {doc.id != null ? (
            <Tooltip label={t('app.deals.docs.download')}>
              <ActionIcon
                variant="subtle"
                color="gray"
                aria-label={t('app.deals.docs.download')}
                loading={download.isPending && download.variables === doc.id}
                onClick={() => download.mutate(doc.id!)}
              >
                <IconDownload size={18} />
              </ActionIcon>
            </Tooltip>
          ) : null}
        </Group>
      ))}
    </Stack>
  );
}
